import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { LangPicker } from 'src/components/lang-picker';
import { getUrlParams } from 'src/utils/helpers';
import { SourceInterface } from 'src/api';
import { CallIcon } from './call-icon';
import { CloseIcon } from './close-icon';
import { LegalEntityCallIcon } from './le-call-icon';
import './style.scss';

interface IntroFormProps {
    source?: SourceInterface;
    onAgreeSubmit?: () => void;
    hideNextBtn?: boolean;
    onClose: () => void;
}

export const IntroForm: FC<IntroFormProps> = (props) => {
    const { t, i18n } = useTranslation('intro');
    const source = props.source;
    const interfaceType = window.VBwidgetConfig.interfaceType;
    const forLegalEntities = interfaceType === 'legal-entity';
    const forMarket = interfaceType === 'market';
    const shownLikeLegalEntity = forLegalEntities || forMarket;
    const video = t('title');
    const sip = t('sip-title');
    const localCall = source && source.callType == 'sip' ? sip : video;

    useEffect(() => {
        const paramString = window.location.href.split('?')[1] || '';
        const language = getUrlParams(paramString).lang;
        if (language && ['ru', 'kz', 'en'].includes(language)) {
            i18n.changeLanguage(language);
        }
    }, []);

    return <div className='vb-intro-page'>
        <div className='vb-intro-container'>
            <div className='vb-intro-container__header'>
                <div className='vb-close-icon-container' onClick={props.onClose}>
                    <CloseIcon />
                </div>
                <header>{localCall}</header>
                <LangPicker className='vb-intro-lang-picker' />
            </div>
            {
                !props.children && <div className='vb-intro-container__body'>
                    <div className='vb-body-icon'>
                        {shownLikeLegalEntity ? <LegalEntityCallIcon /> : <CallIcon />}
                    </div>
                    <div className='vb-body-header'>
                        {forMarket ? t('description-title-market') : t('description-title')}
                    </div>
                    <div className='vb-body-text'>
                        {forMarket ? t('description-text-market') : t('description-text')}
                    </div>
                </div>
            }

            {props.children && <div className='vb-intro-container__body'>{props.children}</div>}

            <div className='vb-intro-container__footer'>
                {!props.hideNextBtn &&
                    <button
                        onClick={props.onAgreeSubmit}
                        className='vb-btn vb-btn-primary vb-text-white vb-gradient-primary vb-px-5'>{t('action-label')}</button>
                }
            </div>
        </div>
    </div>;
};
